<template>
  <div class="bg-white mt-3 p-3 activity-type-create col-12">
    <div class="d-flex title-bar-block mb-2">
      <div class="icon-block me-4">
        <button id="back-btn" v-b-tooltip.hover :title="$backLabel()" @click="cancel()">
          <i class="fa fa-chevron-left text-white" aria-hidden="true"></i>
        </button>
      </div>
      <div class="text">
        <span class="me-2">{{ $translate("add_role") }}</span>
      </div>
    </div>
    <b-overlay :show="submitting" rounded="sm">
      <b-form id="role-form" class="form-sample" @submit.prevent="create()">
        <b-row>
          <b-col cols="12">
            <label class="mb-3"
              ><strong
                >{{ $nameLabel() }}<span class="red">*</span></strong
              ></label
            >
            <b-form-input
              id="input-name"
              required
              v-custom-validation="$textRequired()"
              :placeholder="$translate('enter_name')"
              v-model="model.name"
              trim
            ></b-form-input>
          </b-col>
          <b-col cols="12" md="2" class="mt-3 d-flex align-items-center">
            <div class="form-check me-3">
              <label class="form-check-label">
                <input
                  type="checkbox"
                  id="input-is_default"
                  v-model="model.mobile_access"
                  name="input-is_default"
                  :value="1"
                  :unchecked-value="0"
                />
                <i class="input-helper"></i>
              </label>
            </div>
            <label
              id="is_default-group"
              for="input-is_default"
              class="mb-1 ms-2"
              ><strong> {{ $translate("mobile_access") }}</strong></label
            >
          </b-col>
          <b-col cols="12" md="2" class="mt-3 d-flex align-items-center">
            <div class="form-check me-3">
              <label class="form-check-label">
                <input
                  type="checkbox"
                  id="input-is_default2"
                  v-model="model.web_access"
                  name="input-is_default"
                  :value="1"
                  :unchecked-value="0"
                />
                <i class="input-helper"></i>
              </label>
            </div>
            <label
              id="is_default-group2"
              for="input-is_default2"
              class="mb-1 ms-2"
              ><strong> {{ $translate("web_access") }}</strong></label
            >
          </b-col>
          <b-col cols="12" class="my-3">
            <label class="mb-3"
              ><strong>{{ $translate("permissions") }}</strong>
            </label>
            <permission-groups v-model="model.permissions"></permission-groups>
          </b-col>
          <b-col cols="12" class="my-3">
            <label class="form-control-label mb-3"
              ><strong>{{
                $translate("activity_type_permissions")
              }}</strong></label
            >
            <activity-permission-groups
              v-model="model.activity_permissions"
            ></activity-permission-groups>
          </b-col>

          <b-col cols="12" class="d-flex gap-2 mt-3 justify-content-center">
            <b-button id="submit-btn"
              v-if="hasPermissionCreate"
              type="submit"
              variant="info"
              class="float-right btn-fw"
              :disabled="submitting ? true : false"
              >{{
                submitting
                  ? this.$translate("creating_role")
                  : this.$translate("create_role")
              }}</b-button
            >
            <b-button
              id="cancel-btn"
              @click="cancel()"
              variant="info"
              class="float-right btn-fw"
              :disabled="submitting ? true : false"
              >{{ $cancelLabel() }}</b-button
            >
          </b-col>
        </b-row>
      </b-form>
    </b-overlay>
  </div>
</template>

<script>
import PermissionGroups from "@/components/PermissionGroups";
import permissionsMixins from "@/mixins/permissionsMixins";
import popupMixins from "@/mixins/popupMixins";
import ActivityPermissionGroups from "@/components/ActivityPermissionGroups";

export default {
  name: "roles-createForm",
  mixins: [permissionsMixins, popupMixins],
  components: { PermissionGroups, ActivityPermissionGroups },
  props: [],
  data: () => {
    return {
      model: {
        name: "",
        web_access: false,
        mobile_access: true,
        permissions: [],
        activity_permissions: [],
      },
      submitting: false,
      hasErrors: false,
    };
  },
  computed: {},
  watch: {},
  methods: {
    cancel() {
      this.$emit("cancel");
    },
    create() {
      this.$validator.validate().then((valid) => {
        if (valid) {
          const model = { ...this.model };
          this.submitting = true;
          this.$store
            .dispatch("roles/create", model)
            .then(() => {
              this.$emit("success", this.$translate("created"));
            })
            .catch((resp) => {
              const error = resp.response.data.error.message;
              this.$emit("error", error, model.name);
            })
            .finally(() => {
              this.submitting = false;
            });
        }
      });
    },
  },
  mounted: function () {
    this.$store.dispatch("permissions/all");
  },
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
